import {useEffect} from "react";
import {useSelector} from "react-redux";
import {axiosHandler} from "../lib/utils";
// Called by mounted article screens only; list/prefetch requests do not count.
export default function useArticleOpen(id,ready){
 const auth=useSelector(s=>s.auth);
 useEffect(()=>{if(!id||!ready||!auth?.accessToken)return;let active=true,timer;let attempts=0;
 const send=async()=>{attempts++;try{await axiosHandler({url:`ai/article-opened/${encodeURIComponent(id)}`,method:"post",state:{auth},data:{}});}catch(_){if(active&&attempts<3)timer=setTimeout(send,attempts*1500);}};
 void send();return()=>{active=false;clearTimeout(timer);};},[id,ready,auth?.accessToken]);
}
